import { ref } from "vue";

// 배포(서버 업데이트)로 옛 해시 청크가 삭제되면, 이미 열려 있던 탭에서 아직 로드 안 된 페이지를
// 열 때 동적 import 가 실패한다(stale chunk). 그 순간 true 로 바뀌어 전역 "새로고침" 토스트를 띄운다.
export const updateAvailable = ref(false);

export function markUpdateAvailable(): void {
  updateAvailable.value = true;
}

// 동적 import 실패(= 배포로 청크 사라짐) 메시지 판별. 브라우저별 문구가 달라 폭넓게 매칭.
export function isChunkLoadError(err: unknown): boolean {
  const msg = String((err as { message?: string } | null | undefined)?.message ?? err ?? "");
  return /dynamically imported module|Failed to fetch|Importing a module script failed|error loading dynamically imported/i.test(msg);
}
